import { exeRequest } from '../utils/APIUtils'

const buildQuery = (params = {}) => {
  const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
    if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
    acc[k] = Array.isArray(v) ? v.join(',') : v;
    return acc;
  }, {});
  const qs = new URLSearchParams(cleaned).toString();
  return qs ? `?${qs}` : '';
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    get: async () => exeRequest(`/admin/partenaires`, "GET"),

    getList: async (params) => exeRequest(`/admin/partenaires${buildQuery(params)}`, "GET"),

    getById: async (id) => exeRequest(`/admin/partenaires/${id}`, "GET"),

    getByIdWithQuery: async (id, params) =>exeRequest(`/admin/partenaires/${id}${buildQuery(params)}`, "GET"),

    getOperationsByChauffeur: async (id) => exeRequest(`/admin/operations/${id}`, "GET"),

    getStatsInscriptions: async (periode = 'jour') => exeRequest(`/admin/stats-inscriptions?type=${periode}`, "GET"),


    //Désactiver un utilisateur (PATCH)
    desactiver: async (id) => exeRequest(`/admin/partenaires/${id}/desactiver`, "PATCH"),

    //Supprimer un utilisateur et le détacher du véhicule (DELETE)
    supprimer: async (id) => exeRequest(`/admin/partenaires/${id}/supprimer`, "DELETE"),

    updatePartenaire: async (id, data) => exeRequest(`/admin/partenaires/${id}`, "PUT", data),

}